module.exports = __webpack_public_path__ + "img/bg-footer.96567bbd.jpg";